__turbopack_context__.v({
  "action": "WelcomePanel-module__VAUmkG__action",
  "avatar": "WelcomePanel-module__VAUmkG__avatar",
  "avatarContainer": "WelcomePanel-module__VAUmkG__avatarContainer",
  "badge": "WelcomePanel-module__VAUmkG__badge",
  "badgeCompact": "WelcomePanel-module__VAUmkG__badgeCompact",
  "badgeIcon": "WelcomePanel-module__VAUmkG__badgeIcon",
  "content": "WelcomePanel-module__VAUmkG__content",
  "description": "WelcomePanel-module__VAUmkG__description",
  "heading": "WelcomePanel-module__VAUmkG__heading",
  "label": "WelcomePanel-module__VAUmkG__label",
  "labels": "WelcomePanel-module__VAUmkG__labels",
  "panel": "WelcomePanel-module__VAUmkG__panel",
  "profileCard": "WelcomePanel-module__VAUmkG__profileCard",
  "profileCardInner": "WelcomePanel-module__VAUmkG__profileCardInner",
  "profileCompany": "WelcomePanel-module__VAUmkG__profileCompany",
  "profileDetails": "WelcomePanel-module__VAUmkG__profileDetails",
  "profileInfo": "WelcomePanel-module__VAUmkG__profileInfo",
  "profileJobTitle": "WelcomePanel-module__VAUmkG__profileJobTitle",
  "profileName": "WelcomePanel-module__VAUmkG__profileName",
  "settingsLink": "WelcomePanel-module__VAUmkG__settingsLink",
});
